import {
    in_free_spins,
    server_result,
    set_inanim,
    wi,
    states,
    server_config,
    fps
} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_audio_continue,
    madnes_audio_loop,
    madnes_audio_pause,
    madnes_audio_play,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_anim_add, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {
    madnes_add_group, madnes_add_img, madnes_add_sprite, madnes_add_to_group,
    madnes_get_angle,
    madnes_get_pos_x, madnes_key_exist,
    madnes_set_alpha, madnes_set_angle, madnes_set_pos,
    madnes_set_pos_x,
    madnes_set_pos_y, madnes_set_scale,
    madnes_set_texture
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_add_to_render,
    madnes_move_to,
    madnes_rem_from_render,
    madnes_rotate_to, madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_add_win,
    madnes_microtime,
    madnes_money_to_coin,
    madnes_set_win,
    win
} from "../framework/src/engine/madnes/madnes";
import {result_control_pos, set_fromsaloon, set_result_control_pos, wanted_result_control_part} from "./wanted_core";
import {wanted_freespin_show} from "./wanted_anims";
import {STATES} from "../framework/src/states/states";

var gun_pos = 0;
var saloon_can_shoot = 0;
var multi_win = 2;
var colt_angle = 0;
var colt_angle_max = 5;
var angle = 0;
var angle_shoot = 0;
var shoot_pos = 0;
var stop_wheel = 0;
var stop_gun = 0;
var hide_gun = 0;
var wheel_speed = 2;
var win_table;
var win_table_win;
var win_size = 0.01;
var win_angle = 0;
var win_anim_pos_2 = 0;
// Promenne pro hru saloon konec
export var insaloon = 0;

export function set_insaloon(bool) {
    insaloon = bool;
}

// Vstup do saloonu -> zavreni dveri
export function wanted_saloon_start()
{
    states.setState(STATES.BONUS);

    set_inanim(1); // inanim = 1;
    set_insaloon(1); // insaloon = 1;

    // madnes_hide_btns();

    if(in_free_spins)
    {
        madnes_audio_pause('BACKGROUND_FS');
    }
    else
    {
        madnes_audio_pause('BACKGROUND');
    }

    madnes_move_to("logo_reels", wi / 2, -100, 1000);

    madnes_audio_play('SL_IN');
    madnes_set_pos_x("bonus_Intro", 0);
    madnes_anim_play("bonus_Intro", "to_start");
}

// Dvere jsou zavreny. Prepozicovat textury.
export function wanted_saloon_to_middle()
{
    madnes_set_alpha("background", 0);
    madnes_set_alpha("bckground2", 0);

    wanted_saloon_rotate_wheel_dir = 0;

    if(in_free_spins)
    {
        madnes_set_alpha("freespin_bg_0", 0);
        madnes_set_alpha("freespin_bg_1", 0);
        madnes_set_alpha("freespin_bg_2", 0);
        madnes_set_alpha("freespin_bg_3", 0);
        madnes_set_alpha("freespin_bg_4", 0);

        madnes_set_pos_x("freespin_bg_0", -9999);
        madnes_set_pos_x("freespin_bg_1", -9999);
        madnes_set_pos_x("freespin_bg_2", -9999);
        madnes_set_pos_x("freespin_bg_3", -9999);
        madnes_set_pos_x("freespin_bg_4", -9999);

        madnes_set_alpha("free1", 0);
        madnes_set_alpha("free2", 0);
        madnes_set_alpha("table_free-spins", 0);

    }

    for(var i in server_config.logic.reels)
    {
        for(var j in server_config.logic.reels[i])
        {
            madnes_set_alpha("reels_bufer_" + i + "_" + j, 0);
        }
        madnes_set_alpha("reels_bufer_" + i + "_S0", 0);
        madnes_set_alpha("reels_bufer_" + i + "_S1", 0);
        madnes_set_alpha("reels_bufer_" + i + "_S2", 0);
    }

    madnes_set_alpha("bonus_shot", 0);
    madnes_set_alpha("bonus_bg", 1);
    madnes_set_alpha("bonus_wheel", 1);
    madnes_set_alpha("bonus_colt", 1);
    madnes_set_alpha("bonus_paper", 1);
    madnes_set_alpha("button_fire", 1);
    madnes_set_alpha("button_fire_text", 1);

    saloon_can_shoot = 0;

    win_size = 0.01;
    win_angle = 0;

    stop_gun = 0;
    hide_gun = 0;
    stop_wheel = 0;

    madnes_set_pos_y("bonus_colt", 740 + 400);

    madnes_set_pos_y("bonus_paper", 520 + 400);
    madnes_set_pos_y("button_fire", 550 + 400);
    madnes_set_pos_y("button_fire_text", 550 + 400);

    madnes_set_texture("button_fire", "button_FIRE_disabled");

    madnes_audio_loop('BACKGROUND_SALOON');

    madnes_anim_play("bonus_Intro", "to_end");
    wanted_saloon_to_end();
}

// Otevrit dvere do saloonu.
function wanted_saloon_to_end()
{
    //wanted_saloon_gun_move1();
    setTimeout(wanted_saloon_rotate_wheel, 1000 / 60);
    //madnes_audio_loop("SL_PLAY_10");// ODEBRANO 20170524

    // madnes_fullscreen_disable();
    madnes_move_to("bonus_colt",  madnes_get_pos_x("bonus_colt"),  740 + ( 200 - ( 20 * 10 ) ), 1000)
    madnes_move_to("bonus_paper", madnes_get_pos_x("bonus_paper"), 520 + ( 200 - ( 20 * 10 ) ), 1000)
    madnes_move_to("button_fire_text", madnes_get_pos_x("button_fire_text"), 550 + ( 200 - ( 20 * 10 ) ), 1000)
    madnes_move_to("button_fire", madnes_get_pos_x("button_fire"), 550 + ( 200 - ( 20 * 10 ) ), 1000, wanted_saloon_gun_move1)

}

var wanted_wheel_speed_to_obj = [];
function wanted_wheel_speed_to(speed, total_time)
{
    wanted_wheel_speed_to_obj['start'] = madnes_microtime(true);
    wanted_wheel_speed_to_obj['total_time'] = total_time;
    wanted_wheel_speed_to_obj['start_speed'] = wheel_speed;
    wanted_wheel_speed_to_obj['end_speed'] = speed;
    madnes_add_to_render(wheel_speed_add);
}

function wheel_speed_add()
{
    var diff_time = ( madnes_microtime(true) - wanted_wheel_speed_to_obj['start'] ) * 1000;
    var perc = ( 100 / wanted_wheel_speed_to_obj['total_time'] ) * diff_time;
    if(perc >= 100)
    {
        wheel_speed = wanted_wheel_speed_to_obj['end_speed'];
        madnes_rem_from_render(wheel_speed_add);
    }
    else
    {
        var speed = ( wanted_wheel_speed_to_obj['end_speed'] - wanted_wheel_speed_to_obj['start_speed'] ) * ( perc / 100 ) + wanted_wheel_speed_to_obj['start_speed'];
        wheel_speed = speed;
    }
}


// Vysunuti zbrane ze spodni cvasti obrazovky do hry
export function wanted_saloon_gun_move1()
{
    setTimeout(wanted_saloon_gun_move2, 1000/fps);
    wanted_wheel_speed_to(8, 2000);

    setTimeout(function() {
        madnes_anim_play("bonus_wheel", "blur");
        madnes_anim_play("bonus_shot", "blur");
    }, 1800);

    setTimeout(wanted_saloon_can_shoot, 4000);
}

// Zapnuti moznosti strilet
function wanted_saloon_can_shoot()
{
    saloon_can_shoot = 1;
    setTimeout(wanted_saloon_shoot, 20000);
    madnes_set_texture("button_fire", "button_FIRE_basic");
}

// Vystrel zbrane
export function wanted_saloon_shoot()
{
    if(saloon_can_shoot)
    {
        saloon_can_shoot = 0;
        stop_gun = 1;

        madnes_set_texture("button_fire", "button_FIRE_press");

        setTimeout(function() {
            madnes_set_alpha("button_fire", 0);
            madnes_set_alpha("button_fire_text", 0);
            madnes_set_alpha("bonus_paper", 0);
        }, 200);

        setTimeout(function () {
            madnes_set_alpha("bonus_flash", 1);
            madnes_audio_play('SL_GUNSHOT');
        }, 700);

        setTimeout(function() {
            madnes_set_alpha("bonus_flash", 0);
        }, 750);

        madnes_anim_play("bonus_colt", "shoot");

        // madnes_fullscreen_enable();
    }
}

// Konec vystrelu -> nastaveni otvoru prustrelu + nastaveni vyhry
var tmp_win_loc = 0;
var tmp_win_tot = 0;
export function wanted_saloon_shoot_end()
{
    tmp_win_loc = 0;
    tmp_win_tot = 0;
    if(server_result != null && server_result.result.win != null && server_result.result.lineWins[0] != null && server_result.result.lineWins[0].win != null)
    {
        tmp_win_loc = server_result.result.lineWins[result_control_pos].win; //madnes_money_to_coin( server_result.result.lineWins[result_control_pos].win ); // Local
        for(var pos in server_result.result.gameSpecifics.linewins)
        {
            if(server_result.result.gameSpecifics.linewins[pos].index == result_control_pos)
            {
                tmp_win_tot = server_result.result.gameSpecifics.linewins[pos].totalWin; //madnes_money_to_coin( server_result.result.gameSpecifics.linewins[pos].totalWin ); // Total
                multi_win = server_result.result.gameSpecifics.linewins[pos].bonusFactor;
            }
        }

    }
    else
    {
        multi_win = 2;
    }

    if(multi_win == 2)
    {
        shoot_pos = 0;
    }
    else if(multi_win == 3)
    {
        shoot_pos = 1;
    }
    else if(multi_win == 5)
    {
        shoot_pos = 2;
    }

    if(angle > 160 && angle < 160 + 180 && shoot_pos == 0)
    {
        shoot_pos += 3
    }
    if(angle > 100 && angle < 100 + 180 && shoot_pos == 1)
    {
        shoot_pos += 3
    }
    if(angle > 30 && angle < 30 + 180 && shoot_pos == 2)
    {
        shoot_pos += 3
    }

    wanted_wheel_speed_to(2, 1000);
    setTimeout(function() {
        wanted_wheel_speed_to(1, 1000);
    }, 2000);

    madnes_anim_play("bonus_wheel", "stop");
    madnes_anim_play("bonus_shot", "stop");

    setTimeout(wanted_saloon_gun_move4, 500);
    hide_gun = 1;
    setTimeout(function() {
        stop_wheel = 1;
    }, 1000);
}


// Vravoravy pohyb zbrane doprava
var wanted_saloon_gun_move2_cnt = 0;
function wanted_saloon_gun_move2()
{
    wanted_saloon_gun_move3_cnt = 0;
    wanted_saloon_gun_move2_cnt = wanted_saloon_gun_move2_cnt * 1 + 1;
    madnes_rotate_to("bonus_colt", colt_angle_max + ( -1 * madnes_get_angle("bonus_colt") ) , 1, 400 + 200 * Math.random(), function()
    {
        madnes_rotate_to("bonus_colt", colt_angle_max, -1, 500 + 200 * Math.random(), function()
        {
            if(stop_gun)
            {
                return;
            }

            if(Math.random() * 100 > 50 || wanted_saloon_gun_move2_cnt > 2)
            {
                wanted_saloon_gun_move3();
            }
            else
            {
                wanted_saloon_gun_move2();
            }
        });
    });
}

// Vravoravy pohyb zbrane doleva
var wanted_saloon_gun_move3_cnt = 0;
function wanted_saloon_gun_move3()
{
    wanted_saloon_gun_move2_cnt = 0;
    wanted_saloon_gun_move3_cnt = wanted_saloon_gun_move3_cnt * 1 + 1;
    madnes_rotate_to("bonus_colt", colt_angle_max + ( -1 * madnes_get_angle("bonus_colt") ) , -1, 400 + 200 * Math.random(), function()
    {
        madnes_rotate_to("bonus_colt", colt_angle_max, 1, 500 + 200 * Math.random(), function()
        {
            if(stop_gun)
            {
                return;
            }

            if(Math.random() * 100 > 50 || wanted_saloon_gun_move3_cnt > 2)
            {
                wanted_saloon_gun_move3();
            }
            else
            {
                wanted_saloon_gun_move2();
            }
        });
    });
}

// Dovravorani zbrane na stred pri vystrelu
function wanted_saloon_gun_move4()
{
    madnes_move_to("bonus_colt", madnes_get_pos_x("bonus_colt"), 740 + ( 200 - ( -30 * 10 ) ), 1000)
}


// Obsluha rotace kola
var wanted_saloon_rotate_wheel_dir = 0;
function wanted_saloon_rotate_wheel()
{
    if(wanted_saloon_rotate_wheel_dir == 0)
    {
        if(
            Math.random() * 100 < 50
        )
        {
            wanted_saloon_rotate_wheel_dir = 1;
        }
        else
        {
            wanted_saloon_rotate_wheel_dir = -1;
        }
    }

    angle = madnes_get_angle("bonus_wheel");

    angle_shoot = angle + ((360 / 6) * shoot_pos) - 10;
    while(angle_shoot >= 360)
    {
        angle_shoot = angle_shoot * 1 - 360;
    }

    var precision = 2;

    if(!stop_wheel)
    {
        madnes_rotate_to("bonus_wheel", 360 / ( 6 * precision ) , wanted_saloon_rotate_wheel_dir, 1000 / ( wheel_speed * precision ), wanted_saloon_rotate_wheel);
    }
    else
    {
        if(angle_shoot >= 48 && angle_shoot <= 52 && wheel_speed <= 2)
        {
            //madnes_audio_stop('SL_PLAY_10');// ODEBRANO 20170524
            madnes_audio_stop('BACKGROUND_SALOON');
            madnes_audio_play('SL_WIN');
            wanted_saloon_show_win();
            return;
        }
        else
        {
            madnes_rotate_to("bonus_wheel", 360 / ( 6 * precision ) , wanted_saloon_rotate_wheel_dir, 1000 / ( wheel_speed * precision ), wanted_saloon_rotate_wheel);
        }
    }

    if(hide_gun)
    {
        madnes_set_angle("bonus_shot", angle_shoot);
        madnes_rotate_to("bonus_shot", 360 / ( 6 * precision ) , wanted_saloon_rotate_wheel_dir, 1000 / ( wheel_speed * precision ) );
        madnes_set_alpha("bonus_shot", 1);
    }
    else
    {
        madnes_set_alpha("bonus_shot", 0);
    }
}


// Zacatek zobrazeni vyherniho papiru
function wanted_saloon_show_win()
{
    var win_size = 0.01;
    var win_angle = 0;

    if(!madnes_key_exist("win_table"))
    {
        madnes_add_group("win_table");
    }

    if(!madnes_key_exist("bonus_Win_bg"))
    {
        madnes_add_img("bonus_Win_bg", 'bonus_Win-' + multi_win, 0, 0, 1, 0.5, 0.5);
        madnes_add_to_group("win_table", "bonus_Win_bg");
    }
    madnes_set_scale("bonus_Win_bg", win_size, win_size);

    if(!madnes_key_exist("win_table_nums_minsum_multi"))
    {
        madnes_add_sprite("win_table_nums_minsum_multi", "bonus_Winfont_Small", 0, 0, 1, 0.5, 0.5);
        for(var i = 0; i <= 10; i++)
        {
            madnes_anim_add("win_table_nums_minsum_multi", i, [i]);
        }
        madnes_add_to_group("win_table", "win_table_nums_minsum_multi");
    }
    else
    {
        madnes_set_pos("win_table_nums_minsum_multi", 0, 0);
    }

    madnes_anim_play("win_table_nums_minsum_multi", multi_win);

    if(!madnes_key_exist("win_table_nums_minsum_x"))
    {
        madnes_add_sprite("win_table_nums_minsum_x", "bonus_Win-X", 0, 0, 1, 0.5, 0);
        madnes_add_to_group("win_table", "win_table_nums_minsum_x");
    }
    else
    {
        madnes_set_pos("win_table_nums_minsum_x", 0, 0);
    }

    var winMin = "0";
    winMin = madnes_money_to_coin(tmp_win_loc).toString(); // tmp_win_loc.toString();
    for(var i = 0; i < winMin.length; i++)
    {
        var num = parseInt(winMin.substring(i,i+1));
        if(isNaN(num))
        {
            num = 0;
        }
        if(!madnes_key_exist("win_table_nums_minsum_" + i))
        {
            madnes_add_sprite("win_table_nums_minsum_" + i, "bonus_Winfont_Small", 0, 0, 1, 0.5, 0.5);
            for(var j = 0; j <= 10; j++)
            {
                madnes_anim_add("win_table_nums_minsum_" + i, j, [j]);
            }
            madnes_add_to_group("win_table", "win_table_nums_minsum_" + i);
        }
        madnes_set_alpha("win_table_nums_minsum_" + i ,1);
        madnes_set_pos("win_table_nums_minsum_" + i, (45 + (32 * i)) * win_size, 105 * win_size);
        madnes_set_scale("win_table_nums_minsum_" + i, win_size, win_size);
        madnes_anim_play("win_table_nums_minsum_" + i, num);
    }

    var win_big = "0";
    win_big =  madnes_money_to_coin(tmp_win_tot).toString(); // tmp_win_tot.toString();
    for(var i = 0; i < win_big.length; i++)
    {
        var num = parseInt(win_big.substring(i,i+1));
        if(isNaN(num))
        {
            num = 0;
        }
        if(!madnes_key_exist("win_table_nums_bigsim_" + i))
        {
            madnes_add_sprite("win_table_nums_bigsim_" + i, "bonus_Winfont_Big", (-50 + (64 * i)) * win_size, 220 * win_size, 1, 0.5, 0.5);
            for(var j = 0; j <= 10; j++)
            {
                madnes_anim_add("win_table_nums_bigsim_" + i, j, [j]);
            }
            madnes_add_to_group("win_table", "win_table_nums_bigsim_" + i);
        }
        else
        {
            madnes_set_pos("win_table_nums_bigsim_" + i, (-50 + (64 * i)) * win_size, 220 * win_size);
        }
        madnes_set_alpha("win_table_nums_bigsim_" + i, 1);
        madnes_anim_play("win_table_nums_bigsim_" + i, num);
        madnes_set_scale("win_table_nums_bigsim_" + i, win_size, win_size);
    }

    madnes_set_pos("win_table", 630, 330);
    madnes_set_angle("win_table", win_angle);



    madnes_set_scale("win_table_nums_minsum_x", 0, 0);
    madnes_set_scale("win_table_nums_minsum_multi", 0, 0);

    var winMin = "0";
    winMin = madnes_money_to_coin(tmp_win_loc).toString(); // tmp_win_loc.toString();

    var diff = 30;

    var lft = 1 + winMin.length;
    lft = lft / 2;
    lft = lft * -1;
    lft = lft * diff;

    var tmp_time = 1400;

    madnes_scale_to("win_table", 1, 1, tmp_time);
    madnes_scale_to("bonus_Win_bg", 1, 1, tmp_time);
    madnes_scale_to("win_table_nums_minsum_x", 1, 1, tmp_time);
    madnes_move_to("win_table_nums_minsum_x", (lft + diff), 108, tmp_time, wanted_saloon_show_win_rotate2);

    madnes_scale_to("win_table_nums_minsum_multi", 1, 1, tmp_time);
    madnes_move_to("win_table_nums_minsum_multi", lft, 108, tmp_time);

    madnes_rotate_to("win_table", 360 * 10, 1, tmp_time);

    for(var i = 0; i < winMin.length; i++)
    {
        madnes_scale_to("win_table_nums_minsum_" + i, 1, 1, tmp_time);
        madnes_move_to("win_table_nums_minsum_" + i, (lft + ( diff * ( i + 2 ) ) ), 108, tmp_time);
    }

    var win_big = "0";
    win_big = madnes_money_to_coin(tmp_win_tot).toString(); // tmp_win_tot.toString();
    for(var i = 0; i < win_big.length; i++)
    {
        madnes_scale_to("win_table_nums_bigsim_" + i, 1, 1, tmp_time);
        madnes_move_to("win_table_nums_bigsim_" + i, ( - ( 64 * ( win_big.length - 1 ) / 2 ) + ( 64 * i ) ), 220, tmp_time)
    }
}

// Papir dorotoval -> priblizeni k obrazovce a navrat
var wanted_saloon_show_win_rotate2_pos = 0;
function wanted_saloon_show_win_rotate2()
{
    var to = 1;
    if(wanted_saloon_show_win_rotate2_pos == 0)
    {
        wanted_saloon_show_win_rotate2_pos = 1;
        to = 1.1;
    }
    else if(wanted_saloon_show_win_rotate2_pos == 1)
    {
        wanted_saloon_show_win_rotate2_pos = 2;
        to = 1;
    }
    else if(wanted_saloon_show_win_rotate2_pos == 2)
    {
        wanted_saloon_show_win_rotate2_pos = 3;
        to = 1.1;
    }
    else if(wanted_saloon_show_win_rotate2_pos == 3)
    {
        wanted_saloon_show_win_rotate2_pos = 4;
        to = 1;
    }
    else if(wanted_saloon_show_win_rotate2_pos == 4)
    {
        wanted_saloon_show_win_rotate2_pos = 0;

        setTimeout(
            function()
            {
                wanted_saloon_start_back();

                madnes_add_win(tmp_win_tot * 1);



                madnes_set_pos("win_table", -9999, -9999);

                var winMin = "0";
                winMin = madnes_money_to_coin(tmp_win_loc).toString(); // tmp_win_loc.toString();
                for(var i = 0; i < winMin.length; i++)
                {
                    madnes_set_alpha("win_table_nums_minsum_" + i ,0);
                }

                var win_big = "0";
                win_big = madnes_money_to_coin(tmp_win_tot).toString(); // tmp_win_tot.toString();
                for(var i = 0; i < win_big.length; i++)
                {
                    madnes_set_alpha("win_table_nums_bigsim_" + i ,0);
                }

            },
            1500
        );

        return;
    }

    var winMin = "0";
    winMin = madnes_money_to_coin(tmp_win_loc).toString(); // tmp_win_loc.toString();

    var diff = 30;

    var lft = 1 + winMin.length;
    lft = lft / 2;
    lft = lft * -1;
    lft = lft * diff;

    var tmp_time = 350;

    madnes_scale_to("win_table", to, to, tmp_time);
    madnes_scale_to("bonus_Win_bg", to, to, tmp_time);
    madnes_scale_to("win_table_nums_minsum_x", to, to, tmp_time);
    madnes_move_to("win_table_nums_minsum_x", (lft + diff) * to, 108 * to, tmp_time, wanted_saloon_show_win_rotate2);

    madnes_scale_to("win_table_nums_minsum_multi", to, to, tmp_time);
    madnes_move_to("win_table_nums_minsum_multi", lft * to, 108 * to, tmp_time);

    for(var i = 0; i < winMin.length; i++)
    {
        madnes_scale_to("win_table_nums_minsum_" + i, to, to, tmp_time);
        madnes_move_to("win_table_nums_minsum_" + i, (lft + ( diff * ( i + 2 ) ) ) * to, 108 * to, tmp_time);
    }

    var win_big = "0";
    win_big = madnes_money_to_coin(tmp_win_tot).toString(); // tmp_win_tot.toString();
    for(var i = 0; i < win_big.length; i++)
    {
        madnes_scale_to("win_table_nums_bigsim_" + i, to, to, tmp_time);
        madnes_move_to("win_table_nums_bigsim_" + i, ( - ( 64 * ( win_big.length - 1 ) / 2 ) + ( 64 * i ) ) * to, 220 * to, tmp_time)
    }
}


// Ukonceni hry saloon
function wanted_saloon_start_back()
{
    set_fromsaloon(1); // fromsaloon = 1;
    madnes_audio_stop('BACKGROUND_SALOON');
    madnes_audio_play('SL_OUT');

    madnes_anim_play("bonus_Intro", "back_start");
}

// Dvere jsou uzavreny -> prepozicovat na klasickou hru
export function wanted_saloon_back_middle()
{
    madnes_set_alpha("background", 1);
    madnes_set_alpha("bckground2", 1);

    if(in_free_spins)
    {
        wanted_freespin_show(1);
        wanted_freespin_show(2);
        wanted_freespin_show(3);
        wanted_freespin_show(4);
        wanted_freespin_show(5);

        madnes_set_alpha("free1", 1);
        madnes_set_alpha("free2", 1);
        madnes_set_alpha("table_free-spins", 1);
    }

    for(var i in server_config.logic.reels)
    {
        for(var j in server_config.logic.reels[i])
        {
            madnes_set_alpha("reels_bufer_" + i + "_" + j, 1);
        }
        madnes_set_alpha("reels_bufer_" + i + "_S0", 1);
        madnes_set_alpha("reels_bufer_" + i + "_S1", 1);
        madnes_set_alpha("reels_bufer_" + i + "_S2", 1);
    }

    madnes_set_alpha("bonus_shot", 0);
    madnes_set_alpha("bonus_bg", 0);
    madnes_set_alpha("bonus_wheel", 0);
    madnes_set_alpha("bonus_colt", 0);
    madnes_set_alpha("bonus_paper", 0);
    madnes_set_alpha("button_fire", 0);
    madnes_set_alpha("button_fire_text", 0);

    madnes_anim_play("bonus_Intro", "back_end");
}

// Navrat dokoncen.
export function wanted_saloon_back_end()
{
    madnes_move_to("logo_reels", wi / 2, 0, 1000);

    madnes_set_pos_x("bonus_Intro", -9999);

    if(in_free_spins)
    {
        madnes_audio_continue('BACKGROUND_FS');
    }
    else
    {
        madnes_audio_continue('BACKGROUND');
        //madnes_end_round();
    }

    //madnes_show_btns();

    insaloon = 0;
    set_result_control_pos(result_control_pos + 1); //result_control_pos++;
    wanted_result_control_part();
}
